import { ModalModalDocusignProps } from './Modal.type'

const ModalDocusign = ({ src }: ModalModalDocusignProps) => (
  <>
    <dialog id="docusign_modal" className="modal">
      <div className="modal-box w-10/12 max-w-5xl p-0">
        {/* Botão X para fechar o modal */}
        <form method="dialog">
          <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">✕</button>
        </form>

        <iframe
          src={src}
          width="100%"
          height="100%"
          style={{ border: 'none', width: '100%', height: '85vh' }}
        ></iframe>
      </div>
    </dialog>
    <input type="checkbox" id="my_modal_6" className="modal-toggle" />
  </>
)

export default ModalDocusign
